export default "__VITE_ASSET__P4DPfwIRieI8P6q8r4JZRw__ 220w, __VITE_ASSET__$oUiuAXR7gZMKRQU56HW2w__ 325w";